import { T } from "./exports";
import { collectAllElements } from "./TreeHelper";
import { Field, Toggle } from "./UIHelper";

export function ActionEditor({action, onChange, onDelete, screens, allInputVars, dataSources=[], screen=null}) {
  const u = (k, v) => onChange({ ...action, [k]: v });
  const colors = { navigate: T.blueLt, apiCall: T.green, setVar: T.yellow, showElements: T.accentLt };
  const labels = { navigate: "↗ Navigate", apiCall: "API Call", setVar: "✎ Set Var", showElements: "👁 Show Elements" };
  const allEls = screen ? collectAllElements(screen.children||[]) : [];

  return (
    <div style={{ background: T.bgCard, border: `1px solid ${colors[action.type] || T.border}33`, borderRadius: 4, padding: 6, marginBottom: 5 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 5 }}>
        <span style={{ fontSize: 9, color: colors[action.type] || T.textSub, fontWeight: 700 }}>{labels[action.type] || action.type}</span>
        <button onClick={onDelete} style={{ background: "none", border: "none", color: T.red, cursor: "pointer", fontSize: 10, padding: 0 }}>✕</button>
      </div>

      {action.type === "navigate" && (
        <>
          <Toggle label="Use variable for target" value={action.targetMode==="variable"} onChange={v=>u("targetMode",v?"variable":"static")}/>
          {action.targetMode==="variable"
            ?<>
              <Field label="Variable name (holds screen name or ID)" value={action.targetVar||""} onChange={v=>u("targetVar",v)} placeholder="navigateTo"/>
              <div style={{fontSize:8,color:T.textMute,marginTop:2,lineHeight:1.5}}>Set this variable to a screen name (e.g. "Screen 2") via Set Var before navigating.</div>
            </>
            :<Field label="Go to Screen" value={action.targetScreenId||""} onChange={v=>u("targetScreenId",v)}
              opts={[{value:"",label:"— select screen —"},...screens.map(s=>({value:s.id,label:s.name}))]}/>
          }
        </>
      )}

      {action.type === "apiCall" && <>
        <Field label="Name" value={action.name || ""} onChange={v => u("name", v)} placeholder="callDataSource" />
        <Field label="Data Source" value={action.sourceId || ""} onChange={v => u("sourceId", v)} opts={[{ value: "", label: "— select source —" }, ...(dataSources || []).filter(s => s.enabled !== false).map(s => ({ value: s.id, label: `${s.name || s.type} (${s.type})` }))]} />
        <Field label="Store As (optional override)" value={action.storeAs || ""} onChange={v => u("storeAs", v)} placeholder="resultVar" />
        <div style={{fontSize:8,color:T.textMute,lineHeight:1.5,marginTop:2}}>
          Uses API config from the selected Data Source. Legacy URL-based actions still run for older saved sessions.
        </div>
      </>}

      {action.type === "setVar" && <>
        <Field label="Variable Name" value={action.varName || ""} onChange={v => u("varName", v)} placeholder="myVar" />
        <Field label="Value (literal or $varName)" value={action.value || ""} onChange={v => u("value", v)} placeholder="hello or $userName" />
      </>}

      {action.type === "showElements" && <>
        <div style={{fontSize:8,color:T.textSub,marginBottom:5,lineHeight:1.5}}>
          Select elements/groups to make visible when this action fires.<br/>
          <span style={{color:T.yellow}}>Hidden elements</span> are shown with 👁 in the list.
        </div>
        {allEls.length===0&&<div style={{fontSize:8,color:T.textMute}}>No elements on screen yet.</div>}
        <div style={{maxHeight:140,overflowY:"auto",background:T.bg,borderRadius:3,padding:4}}>
          {allEls.map(el=>{
            const checked=(action.elementIds||[]).includes(el.id);
            return(
              <label key={el.id} style={{display:"flex",alignItems:"center",gap:5,padding:"2px 0",cursor:"pointer"}}>
                <input type="checkbox" checked={checked} onChange={e=>{
                  const ids=action.elementIds||[];
                  u("elementIds",e.target.checked?[...ids,el.id]:ids.filter(id=>id!==el.id));
                }} style={{cursor:"pointer",accentColor:T.accentLt}}/>
                <span style={{fontSize:8,color:el.visible===false?T.yellow:T.textSub,paddingLeft:el.depth*8}}>
                  {el.type==="group"?"⬡ ":""}{el.label}
                  {el.visible===false&&<span style={{color:T.yellow,marginLeft:3,fontSize:7}}>👁 hidden</span>}
                </span>
              </label>
            );
          })}
        </div>
      </>}
    </div>
  );
}